import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "3d8afdd8-8447-4a39-9400-8ad664dff653", content: "20 Hz and 4 Hz respectively", options: {} },
  { id: "872a4031-2955-42a9-9f07-4f6a652281f9", content: "4 Hz and 20 Hz respectively", options: {} },
  { id: "1c9c0737-2e30-4744-b51b-597bf0a29f9a", content: "4 Hz and 17 Hz respectively", options: {} },
  { id: "391df115-8a8a-42d9-9414-93d363017674", content: "4 Hz and 70 Hz respectively", options: {} },
  { id: "bd0a3e2f-7ce5-4bad-b733-648f86b8982e", content: "20 Hz and 70 Hz respectively", options: {} },
  { id: "a93e2087-4615-4e26-8167-006f47ef4dba", content: "20 Hz and 300 Hz respectively", options: {} },
];

export const task: Task = {
  id: "cce83a37-74ab-4418-9d69-20b8fbf39d8c",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["391df115-8a8a-42d9-9414-93d363017674"],
};
